import { Reveal, Overline } from "./Reveal";
import { IMAGES } from "@/lib/scroll";

export const Concept = () => (
  <section id="concept" data-testid="concept-section" className="py-28 sm:py-40">
    <div className="max-w-[1400px] mx-auto px-6 sm:px-10 grid lg:grid-cols-12 gap-16">
      <div className="lg:col-span-7">
        <Reveal><Overline>02 — Le concept</Overline></Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-display uppercase tracking-tight leading-[1.02] text-4xl sm:text-6xl mt-6">
            Une semelle.<br />Une idée simple.
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <div className="mt-10 space-y-6 text-[#6E6A66] text-base sm:text-lg leading-relaxed max-w-xl">
            <p>
              SOLAMOVE est une semelle lestée pensée pour s'intégrer naturellement à votre quotidien.
            </p>
            <p className="font-display uppercase tracking-tight text-[#0D0D0D] text-xl sm:text-2xl leading-snug">
              Vous marchez.<br />Vous travaillez.<br />Vous sortez.<br />Vous vivez.
            </p>
            <p>
              SOLAMOVE vous accompagne simplement dans ce que vous faites déjà.
            </p>
          </div>
        </Reveal>
        <Reveal delay={0.3}>
          <ul className="mt-12 space-y-0 border-t border-black/[0.08]">
            {["Pas besoin de bouleverser sa journée", "Pas besoin de trouver plus de temps", "Aucun équipement encombrant"].map((item, i) => (
              <li key={i} className="flex items-center gap-5 py-5 border-b border-black/[0.08]">
                <span className="font-mono-alt text-xs text-[#A8B89A]">0{i + 1}</span>
                <span className="font-display text-lg sm:text-xl text-[#0D0D0D]">{item}</span>
              </li>
            ))}
          </ul>
        </Reveal>
      </div>
      <div className="lg:col-span-5 flex flex-col justify-between gap-10">
        <Reveal delay={0.2} className="overflow-hidden">
          <img src={IMAGES.concept} alt="Marche urbaine premium avec SOLAMOVE" loading="lazy" className="w-full aspect-[4/5] object-cover hover:scale-105 transition-transform duration-[1.8s] ease-out" />
        </Reveal>
        <Reveal delay={0.3}>
          <p className="font-display uppercase tracking-tight leading-[1.05] text-2xl sm:text-4xl">
            Même journée.<br />Mêmes habitudes.<br />
            <span className="text-[#A8B89A]">SOLAMOVE en plus.</span>
          </p>
        </Reveal>
      </div>
    </div>
  </section>
);
